export default ['hr_finiquito_status', 'g_user.hr_employee','hr_employee']
